import { useToast } from "@chakra-ui/react";

const useCustomToast = () => {
  function getStoredUser() {
    try {
      const raw = localStorage.getItem("user");
      if (!raw || raw === "undefined") return null;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  const toast = useToast();
  const showToast = (title, status, description, isClosable = true) => {
    // const user = JSON.parse(localStorage.getItem('user'));
    const user = getStoredUser()
    const toastId = `toast-${Date.now()}-${Math.random()}-${user?._id}`;
    const preId = localStorage.getItem('toast');
    localStorage.setItem('toast', toastId);
    if (toast.isActive(preId)) {
      toast.close(preId);
    }
    toast({
      id: toastId,
      title: title,
      description: description,
      status: status,
      duration: 4000,
      isClosable: isClosable,
      position: "top-right"
    });
  };

  return showToast;
};

export default useCustomToast;
